import React, { useState } from 'react';
import { Flyer } from '../../../Enums/Flyer.enum';
import FlyerPrintButton from './FlyerPrintButton';
import { useAppContext } from '../../../../../Services/AppContext';
import {
	useLazyWorkplaceMemberIdQuery,
	WorkplaceMember,
} from '../../../../../graphql/graphql';
import { useEffectAsync } from '../../../../../helpers';
import Loading from '../../../../../Components/Loading';

interface Props {
	patientId: string;
	parentId?: string | null;
	buttonTitle?: string;
	onClose?: () => void;
}

const FlyerPrintButtonAfterRegistration: React.FC<Props> = ({
	patientId,
	buttonTitle,
	parentId,
	onClose,
}) => {
	const { workplaceId } = useAppContext();
	const [getWorkplaceMemberId] = useLazyWorkplaceMemberIdQuery();
	const [workplaceMember, setWorkplaceMember] = useState<WorkplaceMember>();
	const [isLoading, setIsLoading] = useState(true);

	useEffectAsync(async () => {
		const { workplaceMember } = await getWorkplaceMemberId({
			userId: patientId,
			workplaceId: workplaceId,
		}).unwrap();
		setWorkplaceMember(workplaceMember as WorkplaceMember);

		setIsLoading(false);
	}, []);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<FlyerPrintButton
			workplaceId={workplaceId}
			workplaceMemberId={workplaceMember?.id}
			flyerType={
				parentId
					? Flyer.E_ARCHIVE_INVITATION_CHILDREN
					: Flyer.E_ARCHIVE_INVITATION
			}
			buttonTitle={buttonTitle}
			onClose={onClose}
		/>
	);
};

export default FlyerPrintButtonAfterRegistration;
